var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeatAndFish(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.401,
    height: 18,
    viewBox: "0 0 25.401 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1314",
    "data-name": "Group 1314",
    transform: "translate(-102.299 -469.563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MDI_fish",
    "data-name": "MDI / fish",
    transform: "translate(125.299 494.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_fish",
    "data-name": "Path / fish",
    d: "M8,14l.456-1.8c-1.956-.126-3.7-.96-4.206-2.052A2.3,2.3,0,0,1,4,10.9c-.4.7-1.2.7-2,.7.66,0,.9-.942.9-2.1S2.66,7.4,2,7.4c.8,0,1.6,0,2,.7a2.3,2.3,0,0,1,.252.75A4.205,4.205,0,0,1,7.2,6.992L6.2,5a7.747,7.747,0,0,1,3.2.4,3.415,3.415,0,0,1,1.416,1.626C12.566,7.448,14,8.4,14,9.5c0,1.128-1.5,2.1-3.3,2.5a9.722,9.722,0,0,1-1.4,1.6A1.792,1.792,0,0,1,8,14m3-5.4a.6.6,0,1,0,.6.6A.6.6,0,0,0,11,8.6Z",
    transform: "translate(-25 -27)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "MDI_food-steak",
    "data-name": "MDI / food-steak",
    transform: "translate(114.299 473.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_food-steak",
    "data-name": "Path / food-steak",
    d: "M9.139,2A4.241,4.241,0,0,0,5,6.38a4.172,4.172,0,0,0,2.22,3.54A2.447,2.447,0,0,1,8.6,12.08v.12A1.768,1.768,0,0,0,10.4,14c2.4,0,3-3,3-7.8,0,0,0-4.2-4.26-4.2M10.4,12.8a.567.567,0,0,1-.6-.6v-.12a3.769,3.769,0,0,0-1.98-3.24A2.969,2.969,0,0,1,6.2,6.32a3.408,3.408,0,0,1,.84-2.22,2.781,2.781,0,0,1,2.04-.9,2.894,2.894,0,0,1,3.12,3c0,5.94-1.02,6.6-1.8,6.6m1.08-7.44-4.5,1.62a1.28,1.28,0,0,1-.18-.72,2.951,2.951,0,0,1,.3-1.2l3.12-1.14a2.407,2.407,0,0,1,1.26,1.44m-1.74,4.5,1.68-.6a9.07,9.07,0,0,1-.36,1.98l-.78.3a2.941,2.941,0,0,0-.54-1.68M11.6,6.32a18.674,18.674,0,0,1-.06,1.92l-2.4.9a3.562,3.562,0,0,0-1.08-.78,2.664,2.664,0,0,1-.66-.48Z",
    transform: "translate(0.002)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "MDI_slash-forward",
    "data-name": "MDI / slash-forward",
    transform: "translate(126.299 495.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_slash-forward",
    "data-name": "Path / slash-forward",
    d: "M7,21,14.9,3H17L9.1,21Z",
    transform: "translate(-22 -29)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeatAndFish);
export default __webpack_public_path__ + "static/media/meat_and_fish.1a1b51cb568513dea20a9fa1aa0858b2.svg";
export { ForwardRef as ReactComponent };